import {useState, Fragment, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import {
    Search,
    MoreHorizontal,
    FileText,
    Eye,
    Trash,
    Mail,
    RefreshCw,
    User
} from 'react-feather'
import DataTable from 'react-data-table-component'
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Label,
    FormGroup,
    Row,
    Col,
    Button,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    Modal,
    ModalBody,
    ModalHeader,
    Spinner,
    Table,
    Form
} from 'reactstrap'
import '@styles/react/libs/flatpickr/flatpickr.scss'
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import {
    rdEmailNotificationStatsAction,
    rdSiteViewStatsAction,
    adminGetRds,
    adminUpdateRdStatus,
    adminUpdateRdStatusReset,
    adminDeleteRdStatus,
    adminDeleteRdStatusReset,
    adminExportRds
} from "@src/redux/actions/AdminActions"
import {useFormik} from "formik"
import * as Yup from "yup"
import moment from "moment/moment"
import Flatpickr from "react-flatpickr"
import AdminFilters from "@src/views/components/AdminFilters"
import {successAlert} from "@src/views/components/CustomAlerts"
import queryString from "query-string";
import {confirmAlert} from "../../components/CustomAlerts"

const ManageRDs = () => {
    const [openEmailStatsModal, setOpenEmailStatsModal] = useState(false)
    const [openSiteStatsModal, setOpenSiteStatsModal] = useState(false)

    const {
        rdEmailNotificationsStatsLoading,
        rdEmailNotificationsStatsData,
        rdEmailNotificationsStatsError,

        rdSiteViewStatsLoading,
        rdSiteViewStatsData,
        rdSiteViewStatsError,

        adminGetRDsLoading,
        adminGetRDsData,
        adminGetRDsError,

        adminUpdateRDStatusLoading,
        adminUpdateRDStatusData,
        adminUpdateRDStatusError,

        adminDeleteRDLoading,
        adminDeleteRDData,
        adminDeleteRDError,

        adminRDExportLoading,
        adminRDExportData,
        adminRDExportError
    } = useSelector(store => store.adminReducer)

    const dispatch = useDispatch()

    const siteViewStatsFromDateForm = useFormik({
        initialValues: {
            startDate: [new Date()],
            endDate: [new Date()]
        },
        validationSchema: Yup.object().shape({
            startDate: Yup.array().required('Start date is required.'),
            endDate: Yup.array().required('End date is required.')
        }),
        onSubmit: (values) => {
            const startDate = moment(values.startDate[0]).format('yyyy-MM-DD')
            const endDate = moment(values.endDate[0]).format('yyyy-MM-DD')
            dispatch(rdSiteViewStatsAction({
                start_date: startDate,
                end_date: endDate
            }))
        }
    })

    useEffect(() => {
        if (adminUpdateRDStatusData?.success) {
            successAlert(adminUpdateRDStatusData?.msg)
            dispatch(adminUpdateRdStatusReset())
            dispatch(adminGetRds({}))
        }

        if (adminDeleteRDData?.success) {
            successAlert(adminDeleteRDData?.message)
            dispatch(adminDeleteRdStatusReset())
            dispatch(adminGetRds({}))
        }
    }, [
        adminUpdateRDStatusData,
        adminDeleteRDData
    ])

    useEffect(() => {
        dispatch(adminGetRds({}))
        dispatch(adminExportRds('?data-type=export'))
    }, [])

    const [filtersData, setFiltersData] = useState(null)

    const updateRdStatus = (id) => {
        dispatch(adminUpdateRdStatus({
            id,
            type: "manage"
        }))
    }

    const searchData = (data) => {
        setFiltersData(data)
        const {
            name, email, country, region, state, city, industry, speciality, status
        } = data
        dispatch(adminGetRds({
            name: name,
            email: email,
            country: country ? country.id : '',
            region: region ? region.id : '',
            state: state ? state.id : '',
            city: city ? city.id : '',
            industry: industry ? [industry.id] : [],
            speciality_id: speciality ? speciality.id : '',
            status: status ? status.value : ''
        }))
    }

    const deleteRd = async (id) => {
        const result = await confirmAlert('Confirm', 'Are you sure you want to delete this RD?')
        if (result) {
            dispatch(adminDeleteRdStatus(id))
        }
    }

    const handleCustomPagination = (pageURL) => {
        const parsed = queryString.parseUrl(pageURL);
        let obj = {
            page: parsed?.query?.page
        }
        if (filtersData) {
            const {
                name, email, country, region, state, city, industry, speciality, status
            } = filtersData
            obj = {
                ...obj,
                name: name,
                email: email,
                country: country ? country.id : '',
                region: region ? region.id : '',
                state: state ? state.id : '',
                city: city ? city.id : '',
                industry: industry ? [industry.id] : [],
                speciality_id: speciality ? speciality.id : '',
                status: status ? status.value : ''
            }
        }
        dispatch(adminGetRds(obj))
    }

    const convertArrayOfObjectsToCSV = (array) => {
        let result = ''
        result += "Name, Email, CDR Number, Country, Region, States, Cities, Industry, Speciality , Status, Reg Date, Profile Status, Profile Image, Location, Timezone \n"
        array.forEach(item => {
            result += `${item?.name?.replaceAll(',', '')}, ${item?.email}, ${item?.cdr_number.replaceAll('#', 'No.')}, ${item?.country}, ${item?.region}, ${item?.state}, ${item?.city},`
            result += `${item?.industry.map(e => e.label).join(" | ").replaceAll(',', ' ')},`
            result += `${item?.speciality.map(e => e.label).join(" | ").replaceAll(',', ' ')},`
            result += `${item?.status}, ${item?.reg_date.replaceAll(',', ' ')}, ${item?.profile_status}, ${item?.profile_image}, ${item?.location}, ${item?.timezone}`
            result += "\n"
        })
        return result
    }

    const downloadCSV = (array) => {
        if (array.length > 0) {
            const link = document.createElement('a')
            let csv = convertArrayOfObjectsToCSV(array)
            if (csv === null) return
            const filename = 'Manage-RDS.csv'
            if (!csv.match(/^data:text\/csv/i)) {
                csv = `data:text/csv;charset=utf-8,${csv}`
            }
            link.setAttribute('href', encodeURI(csv))
            link.setAttribute('download', filename)
            link.click()
        } else {
            alert('Data is being loaded, Please wait...')
        }
    }

    const advSearchColumns = [
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    <Link to={`/admin/manage-rd/${row?.id}`} className='font-weight-bold'>{row?.name}</Link>
                )
            }
        },
        {
            name: 'Email',
            selector: 'email',
            sortable: true,
            wrap: true
        },
        {
            name: 'CDR No.',
            selector: 'cdr_number',
            sortable: true,
            wrap: true
        },
        {
            name: 'Industry',
            selector: 'industry',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    <div>
                        {row?.industry?.map((item, index) => (
                            <p key={`rd-industry-${index}`} className='mb-0'>
                                {item?.label}{index !== row?.industry?.length - 1 && ','}
                            </p>
                        ))}
                    </div>
                )
            }
        },
        {
            name: 'Speciality',
            selector: 'speciality',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    <div>
                        {row.speciality?.map((item, index) => (
                            <p key={`rd-speciality-${index}`} className='mb-0'>
                                {item?.label}{index !== row?.speciality?.length - 1 && ','}
                            </p>
                        ))}
                    </div>
                )
            }
        },
        {
            name: 'Reg. Date',
            selector: 'reg_date',
            sortable: true,
            wrap: true
        },
        {
            name: 'Location',
            selector: 'location',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    <div>
                        {row.location}
                    </div>
                )
            }
        },
        {
            name: 'TimeZone',
            selector: 'timezone',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    <div>
                        {row.timezone}
                    </div>
                )
            }
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
            wrap: true,
            cell: row => {
                return (
                    row.status === 'enabled' ? (
                        <span className='badge badge-success badge-sm'>Active</span>
                    ) : (
                        <span className='badge badge-danger badge-sm'>Inactive</span>
                    )
                )
            }
        },
        {
            name: 'Actions',
            cell: row => {
                return (
                    <div className='d-flex pl-2 cursor-pointer'>
                        <UncontrolledDropdown>
                            <DropdownToggle className='pr-1' tag='span'>
                                <MoreHorizontal size={15}/>
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem onClick={() => updateRdStatus(row?.id)}>
                                    <User size={15}/>
                                    <span className='align-middle ml-50'>
                                        {row?.status === 'enabled' ? "Set as Inactive" : "Set as Active"}
                                    </span>
                                </DropdownItem>
                                <DropdownItem tag={Link} to={`/admin/manage-rd/${row.id}`}>
                                    <Eye size={15}/>
                                    <span className='align-middle ml-50'>View Profile</span>
                                </DropdownItem>
                                <DropdownItem className='text-danger' onClick={() => {
                                    deleteRd(row.id).then(r => r)
                                }}>
                                    <Trash size={15}/>
                                    <span className='align-middle ml-50'>Delete</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                )
            }
        }
    ]

    return (
        <Fragment>
            <Card className="brands-my-campaign-table-parent">
                <CardHeader className='d-flex align-items-center justify-content-between flex-wrap border-bottom p-1 px-2'>
                    <CardTitle tag='h4'>Manage RDs</CardTitle>
                    <div>
                        <Button.Ripple className="mr-1"
                                       color='primary'
                                       size='sm'
                                       onClick={() => {
                                           setOpenSiteStatsModal(true)
                                           dispatch(rdSiteViewStatsAction(''))
                                       }}>
                            <Eye size={15}/> Site View Stats
                        </Button.Ripple>
                        <Button.Ripple className="mr-1"
                                       size='sm'
                                       color='primary'
                                       onClick={() => {
                                           setOpenEmailStatsModal(true)
                                           dispatch(rdEmailNotificationStatsAction())
                                       }}>
                            <Mail size={15}/> Email Notifications Stats
                        </Button.Ripple>
                        <Button.Ripple id="BtnTooltip"
                                       color='primary'
                                       size='sm'
                                       onClick={() => downloadCSV(adminRDExportData?.data)}
                                       disabled={adminRDExportLoading}
                        >
                            <FileText size={15}/> {adminRDExportLoading ? 'Preparing Data...' : 'Export (CSV)'}
                        </Button.Ripple>
                    </div>
                </CardHeader>
                <CardBody>
                    <AdminFilters
                        onSubmit={(data) => searchData(data)}
                        onClear={() => {
                            dispatch(adminGetRds({}))
                            setFiltersData(null)
                        }}
                    />

                    {adminGetRDsLoading ? <div className="w-100 my-4 text-center"><Spinner color='primary'/></div> :
                        <DataTable noHeader={true}
                                   columns={advSearchColumns}
                                   className='react-dataTable'
                                   data={adminGetRDsData?.data}
                        />
                    }
                    <CustomPagination
                        pageLinks={adminGetRDsData?.pages}
                        onPaginationClick={handleCustomPagination}
                    />
                </CardBody>
            </Card>
            {/* --- Email Notifications Stats Modal --- */}
            <Modal isOpen={openEmailStatsModal} className='modal-dialog-centered' size="lg">
                <ModalHeader toggle={() => {
                    setOpenEmailStatsModal(false)
                }}>
                    Email Notifications Stats
                </ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <Table>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Notification Type</th>
                            <th>Toggle ON RD's</th>
                            <th>Toggle OFF RD's</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rdEmailNotificationsStatsLoading ? (
                            <tr>
                                <td className="text-center" colSpan="4">
                                    <Spinner color='primary'/>
                                </td>
                            </tr>
                        ) : (
                            rdEmailNotificationsStatsData?.data?.length > 0 ? (
                                rdEmailNotificationsStatsData?.data?.map((item, i) => (
                                    <tr key={i}>
                                        <td><span className='align-middle font-weight-bold'>{++i}</span></td>
                                        <td>{item.title}</td>
                                        <td><span className='badge badge-success'>{item?.toggle_on}</span></td>
                                        <td><span className='badge badge-danger'>{item?.toggle_off}</span></td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan="4">
                                        Sorry! No record found.
                                    </td>
                                </tr>
                            )
                        )}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
            {/* --- Site View Stats Modal --- */}
            <Modal isOpen={openSiteStatsModal} className='modal-dialog-centered' size="lg">
                <ModalHeader toggle={() => {
                    setOpenSiteStatsModal(false)
                }}>
                    Site View Stats
                </ModalHeader>
                <ModalBody style={{minHeight: '50px'}}>
                    <Form onSubmit={siteViewStatsFromDateForm.handleSubmit} autoComplete="off">
                        <Row>
                            <Col md='3'>
                                <FormGroup>
                                    <Label for='start-date'><strong>Start Date:</strong></Label>
                                    <Flatpickr
                                        className='form-control'
                                        id='start-date'
                                        placeholder='Start Date'
                                        value={siteViewStatsFromDateForm.values.startDate}
                                        options={{dateFormat: 'd M, Y'}}
                                        onChange={(e) => {
                                            siteViewStatsFromDateForm.setFieldValue('startDate', e)
                                        }}
                                        disabled={rdSiteViewStatsLoading}
                                    />
                                    {siteViewStatsFromDateForm.errors.startDate && siteViewStatsFromDateForm.touched.startDate && (
                                        <div className='text-danger'>{siteViewStatsFromDateForm.errors.startDate}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md='3'>
                                <FormGroup>
                                    <Label for='end-date'><strong>End Date:</strong></Label>
                                    <Flatpickr
                                        className='form-control'
                                        id='end-date'
                                        placeholder='End Date'
                                        value={siteViewStatsFromDateForm.values.endDate}
                                        options={{dateFormat: 'd M, Y'}}
                                        onChange={(e) => {
                                            siteViewStatsFromDateForm.setFieldValue('endDate', e)
                                        }}
                                        disabled={rdSiteViewStatsLoading}
                                    />
                                    {siteViewStatsFromDateForm.errors.endDate && siteViewStatsFromDateForm.touched.endDate && (
                                        <div className='text-danger'>{siteViewStatsFromDateForm.errors.endDate}</div>
                                    )}
                                </FormGroup>
                            </Col>
                            <Col md='6'>
                                <Button color='primary' type='submit' disabled={rdSiteViewStatsLoading} className="mt-2 mr-1">
                                    <Search size={14}/> Search
                                </Button>
                                <Button color='danger' type='button' disabled={rdSiteViewStatsLoading} className="mt-2"
                                        onClick={() => {
                                            dispatch(rdSiteViewStatsAction(``))
                                            siteViewStatsFromDateForm.resetForm()
                                        }}>
                                    <RefreshCw size={15}/> Clear All
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <Table>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Target</th>
                            <th>Number of RD's</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rdSiteViewStatsLoading ? (
                            <tr>
                                <td className="text-center" colSpan="4">
                                    <Spinner color='primary'/>
                                </td>
                            </tr>
                        ) : (
                            rdSiteViewStatsData?.data ? (
                                <>
                                    <tr>
                                        <td><span className='align-middle font-weight-bold'>1</span></td>
                                        <td><strong>Direct from Login</strong></td>
                                        <td><span className='badge badge-primary'>{rdSiteViewStatsData?.data?.web}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className='align-middle font-weight-bold'>2</span></td>
                                        <td><strong>Email or Other Sources</strong></td>
                                        <td><span className='badge badge-primary'>{rdSiteViewStatsData?.data?.other}</span></td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan="3">
                                        Sorry! No record found.
                                    </td>
                                </tr>
                            )
                        )}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        </Fragment>
    )
}

export default ManageRDs
